<template>
  <div>
    <p>Cette fonction vous permet d’envoyer par mail un lien de paiement avec un motif</p>

    <v-row>
      <v-col cols="12" md="6">
        <label class="field_label">Indiquer l'adresse mail de la personne</label>
        <v-text-field v-model="request.email"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <label class="field_label">Montant sportif</label>
        <v-text-field v-model="request.montant_sportif" @update:modelValue="updateMontant" type="number" min="0"
          outlined append-inner-icon="mdi-currency-eur"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <label class="field_label">Montant options</label>
        <v-text-field v-model="request.montant_option" @update:modelValue="updateMontant" type="number" min="0" outlined
          append-inner-icon="mdi-currency-eur"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <label class="field_label">Montant total (+2€ de frais)</label>
        <v-text-field v-model="request.total" :disabled="!mainStore.authAdmin.hasSuperAdminRights" type="number" min="0"
          outlined append-inner-icon="mdi-currency-eur"></v-text-field>
      </v-col>
    </v-row>

    <div v-if="mainStore.authAdmin.hasSuperAdminRights && has_override_total">
      <v-alert type="warning" variant="tonal">

        Vous avez modifié le montant total, les nouveaux frais pour cette commande seront de {{ recomputedFrais }}€.
      </v-alert>
    </div>


    <v-row>
      <v-col cols="12" md="6">
        <label class="field_label">Motif</label>
        <v-textarea v-model="request.motif"></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-btn class="sm-fullwidth mt-2 inscription_btn" color="primary-dark" @click="send_request">Envoyer le lien de
          paiement</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AdminService from "@/services/admin.service";
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
export default {
  props: ["item"],
  data() {
    return {
      request: {
        id_module: 0,
        id_commande: 0,
        uuid_commande: "",
        id_inscription: 0,
        email: "",
        montant_sportif: 0,
        montant_option: 0,
        total: 0,
        motif: "",
      },
    };
  },
  computed: {
    ...mapStores(useMainStore),
    recomputedFrais() {
      const montant_sportif = parseFloat(this.request.montant_sportif);
      const montant_option = parseFloat(this.request.montant_option);
      const montant_total = parseFloat(this.request.total);
      return montant_total - montant_sportif - montant_option;

    },
    has_override_total() {
      const montant_sportif = parseFloat(this.request.montant_sportif);
      const montant_option = parseFloat(this.request.montant_option);
      const montant_total = parseFloat(this.request.total);
      if (montant_total > 0) {
        return montant_total !== montant_sportif + montant_option + 2;
      }
      return false;
    }
  },
  methods: {
    updateMontant() {
      this.request.total = parseFloat(this.request.montant_sportif) + parseFloat(this.request.montant_option) + 2;
    },
    async send_request() {

      let req = await AdminService.createPaymentRequest(this.request);
      if (req) {
        this.$emit("onCreate");
      }
    },
  },

  created() {
    if (this.item) {
      this.request.id_module = this.item.id_module;
      this.request.id_commande = this.item.id_commande;
      this.request.id_inscription = this.item.id;
      this.request.motif = this.item.nom + " " + this.item.prenom + ": Changement...";
    }
  },
};
</script>

<style lang="scss" scoped></style>